/**
 * 新老流程公共埋点
 * wiki: http://wiki.hellobike.com/pages/viewpage.action?pageId=386402336
 */
import { ubtButtonNew, ubtModuleExposeNew, ubtCustomEvent } from '@/shared/utils/ubt';

export const TP_OCR = '臻有钱_身份认证';

/** 臻有钱_身份认证_清晰分不足 （身份认证页命中清晰分不足埋点） */
export const TC_OCR_NOT_CLEAR = 'finance_updateIdentity';
/** 臻有钱_身份认证_清晰分不足 弹窗 曝光&点击（包括'我知道了'和'关闭'按钮） */
export const TC_OCR_NOT_CLEAR_POPUP = 'finance_loan_ocr_clearCheckPopup';

/** 臻有钱_身份认证_页面进入 曝光 */
export const TE_OCR_ENTER = 'finance_loan_ocr_identify';
/** 臻有钱_身份认证_页面进入_OCR信息带出情况 */
export const TE_OCR_ENTER_MSG_SOURCE = 'finance_loan_ocr_identify_msgSource';
/** 臻有钱_身份认证_页面进入_身份证信息来源 曝光 */
export const TE_OCR_SOURCE = 'finance_loan_ocr_source';
/** 臻有钱_身份认证_双面识别成功_下一步前端校验成功(包含 校验用户和紧急联系人) 曝光 */
export const TE_OCR_NEXT_FRONT_CHECK_SUCCEED = 'finance_loan_ocr_identify_nextStep_frontCheckSucceed';
/** 臻有钱_身份认证_双面识别成功_下一步前端校验失败 (包含 校验用户和紧急联系人) 曝光 */
export const TE_OCR_NEXT_FRONT_CHECK_FAILED = 'finance_loan_ocr_identify_nextStep_frontCheckFailed';
/** 臻有钱_身份认证_双面识别成功_下一步基建校验成功（包括清晰分不足校验成功） 曝光 */
export const TE_OCR_NEXT_BASE_CHECK_SUCCEED = 'finance_loan_ocr_identify_nextStep_backCheckSucceed';
/** 臻有钱_身份认证_双面识别成功_下一步基建校验失败（不包括清晰分不足校验失败） 曝光 */
export const TE_OCR_NEXT_BASE_CHECK_FAILED = 'finance_loan_ocr_identify_nextStep_backCheckFailed';

/** 身份认证点击埋点 */
export const ubtButtonNewOcr = (buttonName: string, otherProps?: Dictionary): void => {
  ubtButtonNew(TP_OCR, buttonName, otherProps);
};

/** 身份认证曝光埋点 */
export const ubtExposeNewOcr = (moduleId: string, otherProps?: Dictionary): void => {
  ubtModuleExposeNew(TP_OCR, moduleId, otherProps);
};

/** 身份认证自定义埋点 */
export const ubtCustomEventNewOcr = (pointId: string, otherProps?: Dictionary): void => {
  ubtCustomEvent(TP_OCR, pointId, otherProps);
};
